import type { PaymentMethod } from '../types/euforms';

export const ONLINE_PAYMENT_METHODS: ReadonlySet<PaymentMethod> = new Set([
  'Multibanco',
  'MB WAY',
  'Cartão de Crédito',
  'Google Pay',
  'Apple Pay',
]);

export const API_KEY_PATTERN = /^(?:[0-9a-f]{4}(?:-[0-9a-f]{4}){4}|demo-[a-z0-9]{4}(?:-[a-z0-9]{4}){2}-[a-z0-9]{3})$/i;
export const API_KEY_HTML_PATTERN = '(?:[0-9a-fA-F]{4}(?:-[0-9a-fA-F]{4}){4}|demo-[a-zA-Z0-9]{4}(?:-[a-zA-Z0-9]{4}){2}-[a-zA-Z0-9]{3})';

export function requiresApiKey(
  paymentOptions: readonly string[] | null | undefined,
): boolean {
  return Boolean(
    paymentOptions?.some((paymentMethod) =>
      ONLINE_PAYMENT_METHODS.has(paymentMethod as PaymentMethod),
    ),
  );
}

export function validatePaymentConfiguration(
  paymentOptions: readonly string[] | null | undefined,
  apiKey: string | null | undefined,
): string | null {
  if (!paymentOptions || paymentOptions.length === 0) {
    return 'Escolhe pelo menos um método de pagamento.';
  }

  if (requiresApiKey(paymentOptions) && !apiKey?.trim()) {
    return 'A Chave API da Eupago é obrigatória para pagamentos online.';
  }

  if (apiKey?.trim() && !API_KEY_PATTERN.test(apiKey.trim())) {
    return 'A Chave API deve ter o formato 322c-1e1b-e392-d02e-bec6 ou demo-xxxx-xxxx-xxxx-xxx.';
  }

  return null;
}
